<main class="w-full bg-white shadow-sm">
  <!-- grid component -->
  <app-dynamic-grid
    [gridConfig]="gridConfig"
    [getDataUrl]="getDataUrl"
    [toggleUrl]="toggleUrl"
    [sortBy]="'modifiedAt'"
    [sortOrder]="'desc'"
    (addClicked)="onAddHandler()"
    (editClicked)="onEditHandler($event)"
    (edit2Clicked)="onEdit2Handler($event)"
    (deleteClicked)="onDeleteHandler($event)"
    (onToggleShowToastEmitter)="showToast($event)"
    [customIsErrorLog]="disableErrorHighlight"
  ></app-dynamic-grid>

  <!-- add/edit pms master entry drawer -->
  <app-drawer
    #practiceDrawer
    [drawerModel]="drawerModel"
    [drawerConfig]="drawerInputConfig"
    [AddDataURL]="addDataUrl"
    [editDataURL]="editDataUrl"
    [ResetURL]="resetUrl"
    [OnDemandLoadURL]="publishTopic"
    [RestartAgentURL]="publishTopic"
    [removeLevel]="false"
    [maxDrawerHeight]="'max-h-[450px]'"
    (refresh)="refreshHandler()"
    [createDrawerTitle]="'Create New Practice'"
    [updateDrawerTitle]="'Update Practice'"
    [hasTwoColumns]="true"
    (resetData)="resetEntry()"
    (modelChange)="onPmsNameChange($event)"
  ></app-drawer>
  
  <!-- edit pms connection string entry drawer -->
  <app-drawer
    #connectionstringDrawer
    [drawerModel]="connectionstringDrawerModel"
    [drawerConfig]="connectionstringDrawerInputConfig"
    [AddDataURL]="add2DataUrl"    
    [editDataURL]="edit2DataUrl"
    [ResetURL]="resetUrl"
    [removeLevel]="false"
    [maxDrawerHeight]="'max-h-[450px]'"
    (refresh)="refreshHandler()"    
    [updateDrawerTitle]="'Update Practice Database Connection Properties'"
    [hasTwoColumns]="true"
    (resetData)="resetEntry()"
  ></app-drawer>
  <app-toast></app-toast>

  <!-- Delete confirmation modal -->
  <app-confirmation-modal
    [isVisible]="showDeleteConfirmation"
    severity="error"
    title="Delete Practice"
    [message]="'Are you sure you want to permanently delete practice ' + (practiceToDelete?.practiceCode || '') + '? This action cannot be undone.'"
    (onActionEventEmitter)="onDeleteConfirmation($event)"
  ></app-confirmation-modal>
</main>
